export enum PRICING_OVERRIDE_STATUS {
    PAST = 'past',
    CURRENT = 'current',
    SCHEDULED = 'scheduled',
}

/**
 * A per-subscription multiplier over the plan item's base price.
 *
 * `coefficient` is a plain multiplier, not a fraction: '5.0000' means five times the plan's base
 * price. It is deliberately never shown on an invoice — the document carries only the final price.
 */
export type SubscriptionItemPricingOverride = {
    id: string;
    created_at: string;
    modified_at: string;
    version_number: number;
    status: PRICING_OVERRIDE_STATUS;
    valid_from: string;
    valid_to: string | null;
    coefficient: string;
};
